export default __webpack_public_path__ + "static/media/property_826.fac83ab5.png";